import React from "react";
import "./QuotePaymentCard.css";

const QuotePaymentCard = ({ msg, isMe, formatDate, formatTime }) => {

    const InfoSection = ({ title, icon, children }) => (
  <div className="info-section">
    <div className="section-header">
      {/* Add back the icon */}
      <div className="section-icon">
        {icon === "calendar" && (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zM5 6h14v2H5V6zm7 7h5v5h-5z"
              fill="currentColor"
              opacity="0.8"
            />
          </svg>
        )}
        {icon === "location" && (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
              fill="currentColor"
              opacity="0.8"
            />
          </svg>
        )}
      </div>
      <span className="section-title">{title}</span>
    </div>
    <div className="section-content">{children}</div>
  </div>
);

  return (
    <div className={`payment-card ${isMe ? "my-card" : "their-card"}`}>
      
      {/* Header */}
      <div className="payment-card-header">
        <div className="header-content">
          <div className="brand-section">
            <div className="brand-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path
                  d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z"
                  fill="currentColor"
                  opacity="0.9"
                />
              </svg>
            </div>
            <div className="brand-text">
              <span className="card-subtitle">Event Proposal</span>
              <span className="card-title">Budget Summary</span>
            </div>
          </div>

          {msg.budget && (
          <div className="amount-section">
            <div className="amount-wrapper">
              {!String(msg.budget || "").trim().startsWith("₹") && <span className="currency">₹</span>}
              <span className="card-amount">{msg.budget}</span>
            </div>
            <span className="amount-label">Total Budget</span>
          </div>
          )}
        </div>
      </div>

      {/* Separator */}
      <div className="card-separator">
        <div className="separator-line" />
        <div className="separator-dot" />
      </div>

      {/* Body */}
      <div className="payment-card-body">

        {/* Event Schedule */}
        {(msg.startDate || msg.endDate) && (
        <InfoSection
          title="Event Schedule"
          icon="calendar"
        >
          <div className="date-range">
            <div className="date-item">
              <span className="date-label">From</span>
              <span className="date-value">{msg.startDate ? formatDate(msg.startDate) : '--'}</span>
            </div>
            <span className="arrow-icon">→</span>
            <div className="date-item">
              <span className="date-label">To</span>
              <span className="date-value">{msg.endDate ? formatDate(msg.endDate) : '--'}</span>
            </div>
          </div>
        </InfoSection>
        )}

        {/* Location */}
        {(msg.flatOrHouseNo || msg.streetName || msg.city || msg.state || msg.postalCode) && (
        <InfoSection
          title="Venue"
          icon="location"
        >
          
          {msg.flatOrHouseNo && <div className="location-text">Flat/House No : {msg.flatOrHouseNo}</div>}
           {msg.streetName && <div className="location-text">Street Name : {msg.streetName}</div>}
          {msg.city && <div className="location-text">City : {msg.city}</div>}
          {msg.state && <div className="location-text"> State : {msg.state}</div>}
          {msg.postalCode && <div className="location-text"> Postalcode : {msg.postalCode}</div>}
        </InfoSection>
        )}

        {/* Notes */}
        {msg.message && (
          <div className="note-section">
            <div className="note-header">
              {/* Add icon back to note header */}
              <div className="note-icon">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
                    fill="currentColor"
                    opacity="0.8"
                  />
                </svg>
              </div>
              <span className="note-title">Special Notes</span>
            </div>
            <p className="note-text">"{msg.message}"</p>
          </div>

          
        )}

        {msg.isRejected && (
  <div className="note-section reject-note">
    <div className="note-header">
      <div className="note-icon">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 
               10-4.48 10-10S17.52 2 12 2zm5 
               13.59L15.59 17 12 13.41 
               8.41 17 7 15.59 
               10.59 12 7 8.41 
               8.41 7 12 10.59 
               15.59 7 17 8.41 
               13.41 12 17 15.59z"
            fill="currentColor"
            opacity="0.9"
          />
        </svg>
      </div>

      <span className="note-title reject-title">
        Quote Rejected
      </span>
    </div>

    <p className="note-text reject-text">
      {msg?.clientId?.username || "User"} has rejected your quote.
    </p>
  </div>
)}
      </div>

      {/* Footer */}
      <div className="payment-card-footer">
        <div className="footer-content">
          <div className="timestamp">
            {/* Add time icon back */}
            <span className="time-icon">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                <path
                  d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                  fill="currentColor"
                  opacity="0.7"
                />
              </svg>
            </span>
            <span className="time-text">
              {msg.createdAt ? formatTime(msg.createdAt) : "Just now"}
            </span>
          </div>

          
          <div className="status-indicator">
            <span className="status-dot" />
            <span className="status-text">Sent</span>
          </div>
        </div>
      </div>

    </div>
  );
};

export default QuotePaymentCard;


// import React from "react";
// import "./QuotePaymentCard.css";

// const QuotePaymentCard = ({ msg, isMe, formatDate, formatTime }) => {

//     const InfoSection = ({ title, children }) => (
//   <div className="info-section">
//     <div className="section-header">
//       <span className="section-title">{title}</span>
//     </div>
//     <div className="section-content">{children}</div>
//   </div>
// );

//   return (
//     <div className={`payment-card ${isMe ? "my-card" : "their-card"}`}>
      
//       {/* Header */}
//       <div className="payment-card-header">
//         <div className="header-content">
//           <div className="brand-section">
//             <div className="brand-icon">
//               <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//                 <path
//                   d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4Z"
//                   fill="currentColor"
//                   opacity="0.9"
//                 />
//               </svg>
//             </div>
//             <div className="brand-text">
//               <span className="card-subtitle">Event Proposal</span>
//               <span className="card-title">Budget Summary</span>
//             </div>
//           </div>

//           <div className="amount-section">
//             <div className="amount-wrapper">
//               <span className="currency">₹</span>
//               <span className="card-amount">{msg.budget}</span>
//             </div>
//             <span className="amount-label">Total Budget</span>
//           </div>
//         </div>
//       </div>

//       {/* Separator */}
//       <div className="card-separator">
//         <div className="separator-line" />
//         <div className="separator-dot" />
//       </div>

//       {/* Body */}
//       <div className="payment-card-body">

//         {/* Event Schedule */}
//         <InfoSection
//           title="Event Schedule"
//           icon="calendar"
//         >
//           <div className="date-range">
//             <div className="date-item">
//               <span className="date-label">From</span>
//               <span className="date-value">{formatDate(msg.startDate)}</span>
//             </div>
//             <span className="arrow-icon">→</span>
//             <div className="date-item">
//               <span className="date-label">To</span>
//               <span className="date-value">{formatDate(msg.endDate)}</span>
//             </div>
//           </div>
//         </InfoSection>

//         {/* Location */}
//         <InfoSection
//           title="Venue"
//           icon="location"
//         >
//           <div className="location-text">{msg.location}</div>
//         </InfoSection>

//         {/* Notes */}
//         {msg.message && (
//           <div className="note-section">
//             <div className="note-header">
//               <span className="note-title">Special Notes</span>
//             </div>
//             <p className="note-text">"{msg.message}"</p>
//           </div>
//         )}
//       </div>

//       {/* Footer */}
//       <div className="payment-card-footer">
//         <div className="footer-content">
//           <div className="timestamp">
//             {msg.createdAt ? formatTime(msg.createdAt) : "Just now"}
//           </div>
//           <div className="status-indicator">
//             <span className="status-dot" />
//             <span className="status-text">Sent</span>
//           </div>
//         </div>
//       </div>

//     </div>
//   );
// };

// export default QuotePaymentCard;
